// The bar's and the drawer's button into the command palette: the bar
// shows it on a desktop, the drawer on a phone (responsive.css). The bar's
// words shorten with the window, down to the glyph alone with its name
// read out; the drawer's copy (full) keeps the sentence.

import { useMediaQuery } from "../../hooks/useMediaQuery";

const SEARCH_GLYPH = String.fromCharCode(8981);
// Both modifiers open the palette (App.tsx); the chip and the not-found
// page name the one this keyboard has.
export const SHORTCUT = /Mac|iPhone|iPad/.test(navigator.userAgent)
  ? String.fromCharCode(8984) + "K"
  : "Ctrl+K";

export function SearchTrigger({ onOpen, full = false }: { onOpen: () => void; full?: boolean }) {
  const short = useMediaQuery("(max-width: 1199px)") && !full;
  const tight = useMediaQuery("(max-width: 900px)") && !full;
  return (
    <button
      type="button"
      className={"cc-search-trigger" + (tight ? " tight" : short ? " short" : "")}
      aria-keyshortcuts="Meta+K Control+K"
      title={tight ? "Search, " + SHORTCUT : undefined}
      onClick={onOpen}
    >
      <span className="glyph" aria-hidden="true">
        {SEARCH_GLYPH}
      </span>
      {tight ? (
        <span className="sr-only">Search</span>
      ) : (
        <span className="label">{short ? "Search" : "Search clients, matters, screens"}</span>
      )}
      {!tight && (
        <span className="kbd" aria-hidden="true">
          {SHORTCUT}
        </span>
      )}
    </button>
  );
}
